/**
 * Application configuration
 */

// Properties
const config = {
    appEnv: window._env_.APP_ENV,
    apiUrl: window._env_.API_URL,
    authUrl: window._env_.AUTH_URL,
    authAppId: window._env_.AUTH_APP_ID,
    basePath: window._env_.BASE_PATH,
    buildTime: window._env_.BUILD_TIME
};

export default config;
